import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable import/no-cycle */
import React from "react";
import CaretDown from "Images/profile/CaretDown.svg";
import SmallX from "Images/profile/small_x.svg";
import { ProductSummaryBlock } from "Root/quiz/components/ProductSummaryBlock";
import styles from "./styles.module.scss";
import useSubscriptionItem from "./useSubscriptionItem";
const SubscriptionItem = ({ title, image_url, onClick, net_price, gross_price, quantity, servings, item_type, flavors, available_flavors, attributes, isEdit, onDeleteItem, sku, delivery_cadence, bags_info, isGetItNow, item_category, item_key, short_name, max_flavors, product_explanation, currentReduxQuantity, description, skus_list, flavor_attribute_description, quantity_description, }) => {
    const { onItemClick, isAdditionalItemOrFb } = useSubscriptionItem({
        title,
        image_url,
        onClick,
        net_price,
        gross_price,
        quantity,
        servings,
        item_type,
        flavors,
        available_flavors,
        attributes,
        isEdit,
        onDeleteItem,
        sku,
        delivery_cadence,
        bags_info,
        isGetItNow,
        item_category,
        item_key,
        short_name,
        max_flavors,
        product_explanation,
        currentReduxQuantity,
        description,
        skus_list,
        flavor_attribute_description,
        quantity_description,
    });
    return (_jsxs("div", { onClick: () => onItemClick(item_type), role: "button", tabIndex: 0, onKeyDown: () => null, className: `${styles.subscription_item} ${isEdit ? styles.subscription_item_edit : ""}`, "data-attr": item_type + "subscription-item-button", children: [_jsx("div", { className: styles.subscription_item_wrapper, children: _jsx(ProductSummaryBlock, { img: image_url, title: title, price: gross_price, netPrice: net_price, quantity: quantity_description, servings: "", customizations: flavor_attribute_description, openDrawer: () => { }, shortname: item_type, showDrawer: false }) }), isEdit && !isAdditionalItemOrFb && !isGetItNow && sku !== "high_nocaff_mango_10" && (_jsx("div", { className: styles.arrow, role: "button", tabIndex: 0, onKeyDown: () => null, onClick: () => onItemClick(item_type), children: _jsx("img", { src: CaretDown, alt: "arrow" }) })), isEdit && (isAdditionalItemOrFb || isGetItNow || sku === "high_nocaff_mango_10") && (_jsx("div", { className: styles.delete_item, role: "button", tabIndex: 0, onKeyDown: () => null, onClick: () => onDeleteItem(sku), children: _jsx("img", { src: SmallX, alt: "close" }) }))] }));
};
export default SubscriptionItem;
